import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client with additional options
export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    },
    global: {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    },
  }
);

// Add error handling for auth state changes
if (typeof window !== 'undefined') {
  supabase.auth.onAuthStateChange((event, session) => {
    console.log('Auth state changed:', event);
    
    if (event === 'SIGNED_OUT') {
      // Clear any cached data
      localStorage.clear();
    } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
      // Validate session
      if (!session?.access_token) {
        console.error('Invalid session detected');
        localStorage.clear();
        window.location.href = '/login';
        return;
      }
      console.log('Session validated successfully');
    }
  });

  // Initialize auth state
  supabase.auth.getSession().catch(error => {
    console.error('Error getting initial session:', error);
    localStorage.clear();
  });
}

// Helper function to check if Supabase is properly configured
const checkSupabaseConfig = () => {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase is not properly configured. Please check your .env file.');
    return false;
  }
  return true;
};